import React from 'react';

import setRef from './setRef';

type Ref<T> = React.Ref<T> | undefined | null;

/**
 * Forks a ref by forwarding the same value to multiple refs (e.g. internal ref + forwarded ref).
 * Returns a callback ref that assigns the node to each ref, or null if all refs are empty.
 *
 * Replaces @material-ui/core/utils/useForkRef for MUI migration.
 */
export default function useForkRef<T>(
  refA: Ref<T>,
  refB: Ref<T>
): React.Ref<T> | null {
  return React.useMemo(() => {
    if (!refA && !refB) {
      return null;
    }
    return (value: T | null) => {
      setRef(refA, value);
      setRef(refB, value);
    };
  }, [refA, refB]);
}
